export default __webpack_public_path__ + "static/media/7.845fd4d6.jpg";